import { PLATFORM_ENVIRONMENT } from '@platform-frontend/platform';

export interface CheckoutEnvironment {
  googlePayMerchantId: string;
}

export const CHECKOUT_ENVIRONMENT: CheckoutEnvironment = { googlePayMerchantId: PLATFORM_ENVIRONMENT.isProduction ? 'BCR2DN4TX7ELTG3B' : '50' };
